const machinesByGroup = (machines, groupName) => {
  return machines.filter(machine => {
    return machine.machine_group === groupName;
  });
};

export default machinesByGroup;
